var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-and-text-block",class:_vm.content.ReverseBlock ? 'reversed' : ''},[_c('img',{attrs:{"src":_vm.content.Image.formats.small.url,"alt":""}}),_c('div',{staticClass:"text-area editor-content",domProps:{"innerHTML":_vm._s(_vm.content.Richtext)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }